module.exports = __webpack_public_path__ + "static/media/k_of_hearts2.6cd39ba9.png";